import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'

import ShaderManifest from '../entities/shaderManifest'
import Settings from '@/glxp/settings'

const VERTICES = [-1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [
  0, 0,
  0, 1,
  1, 1,
  1, 0
]

class Background extends Rendable {
  constructor (scene, needResize = true) {
    super(scene)
    this.hasNormal = false
    this.needResize = needResize
    // this.onlyVertices = false
    var shader = new Shader(ShaderManifest['background'])
    this.initProgram(shader.vert, shader.frag)
    this.initBuffer({
      vertices: this.needResize ? this.scaleWithMargin(VERTICES) : VERTICES,
      uvs: UVS,
      indices: INDICES
    })
    this.initVao()
    this.createUniforms()

    this.opacity = 1
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uColor', 'float3')
    this.createUniform('uRez', 'float2')
    this.createUniform('uImgRez', 'float2')
    this.createUniform('uUseColor')
    this.createUniform('uOpacity')
    this.createUniform('uOverlay')
  }

  applyState () {
    let gl = this.gl
    this.scene.applyDefaultState()
    gl.disable(gl.DEPTH_TEST)
    // gl.disable(gl.BLEND)
  }

  scaleWithMargin (vertices) {
    let v = vertices.slice(0)
    let height = this.scene.height
    let margin = this.scene.marginBottom
    let m = margin / height
    v[4] += m * 2
    v[7] += m * 2
    return v
  }

  render () {
    let gl = this.gl

    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()
    
    if (this.scene.useColor) {
      this.bindUniform('uColor', this.scene.color)
      gl.activeTexture(gl.TEXTURE0)
      gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('black'))
      this.bindUniform('uTexture', 0)
    } else {
      if(!this.scene.textureLoader.getTexture('background')) return
      gl.activeTexture(gl.TEXTURE0)
      gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('background'))
      this.bindUniform('uTexture', 0)
      let texture = this.scene.textureLoader.getImage('background')
      this.bindUniform('uImgRez', [texture.width, texture.height])
    }

    this.bindUniform('uUseColor', this.scene.useColor ? 1 : 0)
    this.bindUniform('uOpacity', this.opacity)
    this.bindUniform('uOverlay', Settings.overlay_cover.value)
    this.bindUniform('uRez', [this.scene.width, this.scene.height - this.scene.marginBottom])

    // this.tl.progress(this.scene.step)
    // this.bindUniform("uColor", )

    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Background
